import type { FC } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withApollo } from '@apollo/client/react/hoc';

import type { AudioPlayerActions } from '../../redux/actions/audioPlayer';
import audioPlayerActions from '../../redux/actions/audioPlayer';
import type { AudioPlayerState } from '../../redux/reducers/audioPlayer';
import type { AudioPlayerTriggerProps } from './AudioPlayerTrigger';
import AudioPlayerTrigger from './AudioPlayerTrigger';

interface AudioPlayerDispatchers {
  dispatchers: AudioPlayerActions;
}

const stateToProps = ({ audioPlayer }): { audioPlayer: AudioPlayerState } => {
  return { audioPlayer };
};

const dispatchToProps = (dispatch): AudioPlayerDispatchers => {
  return {
    dispatchers: bindActionCreators(audioPlayerActions, dispatch),
  };
};

export default compose(
  withApollo,
  connect(stateToProps, dispatchToProps),
)(AudioPlayerTrigger) as FC<Pick<AudioPlayerTriggerProps, 'audioId'>>;
